/**
 * The till: the POS page, the product grid, the size picker, the add-on
 * strip, the customer picker, the QR panel and the cart. The receipt's BODY
 * is not here — it is the printed document and stays Georgian (lib/receipt).
 * Money arrives as a formatted `{sum}` („₾12.00"), so the currency can change
 * in one place later.
 */
export const pos = {
  'pos.priceUpdated': 'ფასი განახლდა: {list}',
  'pos.pluNotFound': 'PLU ვერ მოიძებნა: {plu}',
  'pos.outOfStockName': '{name} — მარაგი ამოიწურა!',
  'pos.onlyUnitInStock': 'მხოლოდ {n} {unit} არის მარაგში',
  'pos.addonsAdded': '+ {n} თანმხლები დაემატა',
  'pos.onlyPiecesInStock': 'მხოლოდ {n} ცალია მარაგში',
  'pos.outOfStock': 'მარაგი ამოიწურა',
  'pos.doubleRead': 'ერთი წაკითხვა — თუ ორი გინდა, გაატარე ხელახლა',
  'pos.barcodeNotFound': 'შტრიხკოდი ვერ მოიძებნა: {code}',
  'pos.onlyInStock': 'მხოლოდ {n} არის მარაგში',
  'pos.shiftClosedHint': 'გაყიდვის დასაწყებად მოლარემ უნდა გახსნას ცვლა PIN-ით და მიუთითოს საწყისი თანხა კასაში.',
  'pos.printLastZ': 'ბოლო Z-რეპორტის ბეჭდვა',
  'pos.viewCart': 'კალათის ნახვა',
  'pos.qtyTitle': 'გაფრთხილება',
  'pos.qtyExists': 'პროდუქცია {name} უკვე არსებობს კალათაში.',
  'pos.qtyAsk': 'ნამდვილად გსურთ რაოდენობის გაზრდა {qty}-მდე?',
  'pos.qtyNo': 'არა, გაუქმება',
  'pos.qtyYes': 'კი, დამატება',

  'grid.notFound': 'ვერ მოიძებნა: {code}',
  'grid.notInStock': '{name} — მარაგში არ არის',
  'grid.search': 'სახელი ან შტრიხკოდი... (F2 · Enter = სწრაფი დამატება)',
  'grid.fit.noYear': '{label} · წელი არ წერია — შეამოწმე',
  'grid.fit.oem': 'OEM {code}',
  'grid.analogs': 'ანალოგი მარაგშია · {n}',
  'grid.searchFit': 'სახელი, კოდი, მანქანა ან OEM... (F2 · Enter = სწრაფი დამატება)',
  'grid.searchFitPhone': 'სახელი, კოდი ან ტელეფონის მოდელი... (F2 · Enter = სწრაფი დამატება)',
  'pos.analogs.title': '„{name}“ მარაგში არ არის',
  'pos.analogs.subtitle': 'ანალოგები, რომლებიც მარაგშია — შეეხე ერთს',
  'grid.subAll': 'ყველა',
  'grid.camera': 'კამერით სკანირება',
  'grid.shown': 'ნაჩვენებია {shown} / {total}',
  'grid.count': '{n} პროდუქტი',
  'grid.filter': 'ფილტრი: {q}',
  'grid.empty': 'პროდუქტები ვერ მოიძებნა',
  'grid.addAria': '{name} — კალათაში დამატება',
  'grid.pickSizeAria': '{name} — ზომის არჩევა',
  'grid.pieces': '{n} ცალი',
  'grid.colors': '{n} ფერი',
  'grid.left': '{n} დარჩა',
  'grid.qtyUnit': '{n} {unit}',
  'grid.leftUnit': '{n} {unit} დარჩა',
  'grid.more': 'კიდევ {n} — მოძებნე სახელით, დაასკანერე ან აირჩიე კატეგორია',
  'grid.scanTitle': 'პროდუქტის სკანირება',

  'promo.combo': 'კომბო',
  'promo.promo': 'აქცია',

  'variant.noColor': 'სხვა',
  'variant.aria': '{name} — {state}',
  'variant.inStock': '{n} მარაგში',
  'variant.qty': '{n} ც.',

  'addon.with': '{name}-სთან ერთად:',
  'addon.offer': 'შეთავაზება:',
  'addon.free': 'უფასო',
  'addon.hide': 'დამალვა',
  'addon.addAllTitle': 'ყველას დამატება — {sum}',

  'customer.pickForBonus': 'კლიენტი (ბონუსისთვის)',
  'customer.bonus': 'ბონუსი {sum}',
  'customer.remove': 'კლიენტის მოხსნა',
  'customer.new': 'ახალი კლიენტი',
  'customer.title': 'კლიენტი',
  'customer.search': 'სახელი ან ტელეფონი…',
  'customer.none': 'კლიენტი ჯერ არ არის',
  'customer.debt': 'ვალი {sum}',

  'qr.checkFailed': 'ვერ შევამოწმე',
  'qr.unavailable': 'გადახდის სერვისი მიუწვდომელია',
  'qr.paidMeanwhile': 'მყიდველმა უკვე გადაიხადა — გაყიდვა იწერება',
  'qr.cancelUnconfirmed': 'გაუქმება ვერ დადასტურდა',
  'qr.cancelNoNet': 'გაუქმება ვერ დადასტურდა — კავშირი არ არის',
  'qr.notConfigured': 'QR-გადახდა ჩართე პარამეტრებში (Keepz)',
  'qr.createFailed': 'QR ვერ შეიქმნა',
  'qr.creating': 'QR იქმნება…',
  'qr.scanHint': 'მყიდველი ტელეფონით ასკანერებს — ბანკის ნებისმიერი აპი',
  'qr.alt': 'QR გადახდისთვის',
  'qr.processing': 'გადახდა მიმდინარეობს…',
  'qr.waiting': 'ველოდებით გადახდას…',
  'qr.autoClose': 'გადახდისთანავე გაყიდვა თავისით დაიხურება — ღილაკი არ სჭირდება.',
  'qr.alreadyPaid': 'მყიდველმა უკვე გადაიხადა?',
  'qr.recorded': 'ჩაწერილი გადახდები',
  'qr.back': 'QR-თან',
  'qr.noOrphans': 'ასეთი გადახდა არ არის — ბოლო შვიდ დღეში ყველა გადახდას გაყიდვა მიედება.',
  'qr.useThis': 'ამ გადახდით ჩაწერა',
  'qr.here': 'აქ {sum}-ია',
  'qr.exactNote': 'თანხა ზუსტად უნდა ემთხვეოდეს — ერთი გადახდა მხოლოდ ერთ გაყიდვაზე აისება.',
  'qr.cancelling': 'QR უქმდება…',
  'qr.paid': 'გადახდილია',
  'qr.booking': 'გაყიდვა იწერება…',
  'qr.bookFailed': 'გადახდა მოვიდა, გაყიდვა ვერ ჩაიწერა — არ დახურო',
  'qr.bookRetry': 'გაყიდვის ჩაწერა თავიდან',
  'qr.leftUnbooked': 'გადახდა {id} ჩაწერის გარეშე დარჩა — მფლობელს უთხარი',
  'qr.closeAnyway': 'მაინც დახურვა',
  'qr.expired': 'QR-ის ვადა გავიდა',
  'qr.canceled': 'გადახდა გაუქმდა',
  'qr.failed': 'გადახდა ვერ შესრულდა',
  'qr.new': 'ახალი QR',

  'pay.cash': 'ნაღდი',
  'pay.card': 'ბარათი',
  'pay.cardWith': 'ბარათი ({bank})',
  'pay.credit': 'ნისია',
  'pay.byCard': 'ბარათით',
  'pay.mixed': 'ნაღდი {cash} + ბარათი {card}',
  'pay.mixedDebt': 'ვალი {sum}',
  'pay.mixedTitle': 'შერეული გადახდა',

  'fiscal.receipt': 'ფისკალური ჩეკი',
  'fiscal.offline': 'offline — მიუწვდომელია',
  'fiscal.on': 'ჩართულია — ჩეკი ამოიბეჭდება',
  'fiscal.off': 'გამორთულია — ჩართე საჭიროებისას',
  'fiscal.will': 'ფისკალური ჩეკი ამოიბეჭდება',
  'fiscal.without': 'ფისკალური ჩეკის გარეშე',
  'fiscal.printing': 'ფისკალური ჩეკი იბეჭდება...',
  'fiscal.mockIssued': 'ჩეკი გაიცა #{id} — ⚠️ ტესტ-რეჟიმი (რეალური ფისკალიზაცია არ მომხდარა)',
  'fiscal.issued': 'ფისკალური ჩეკი გაიცა #{id}',
  'fiscal.failed': 'ფისკალური ჩეკი ვერ გაიცა',
  'fiscal.failedSaved': '{msg} — გაყიდვა შენახულია, ჩეკის გამეორება ისტორიიდან შეიძლება',

  'cart.title': 'კალათა',
  'cart.bonusUsed': 'ბონუსი გამოყენებულია',
  'cart.bonusUse': 'ბონუსის გამოყენება',
  'cart.displayHint': 'გადაიტანე ეს ფანჯარა კლიენტის მონიტორზე',
  'cart.soldBonus': 'გაყიდვა დასრულდა · ბონუსი +{earned}',
  'cart.soldBonusTotal': '(სულ {sum})',
  'cart.sold': 'გაყიდვა წარმატებით დასრულდა!',
  'cart.held': 'კალათა გადადებულია',
  'cart.resumed': 'კალათა დაბრუნდა',
  'cart.err.creditCustomer': 'ნისიისთვის აირჩიეთ კლიენტი',
  'cart.err.pickTerminal': 'აირჩიეთ ბანკის ტერმინალი',
  'cart.err.qrOffline': 'QR-გადახდას ინტერნეტი სჭირდება',
  'cart.err.bonusOffline': 'ბონუსით გადახდას ინტერნეტი სჭირდება',
  'cart.err.bonusQr': 'ბონუსი და QR-გადახდა ერთად ჯერ არ შეიძლება — ბონუსი მოხსენი ან სხვა გადახდა აირჩიე',
  'cart.err.mixCash': 'შეიყვანე რამდენი დაარიცხა ნაღდით',
  'cart.err.mixTerminal': 'აირჩიე ბანკის ტერმინალი',
  'cart.err.mixDebt': 'დარჩენილი თანხა ვალია — აირჩიე კლიენტი',
  'cart.products': 'პროდუქტები',
  'cart.positions': '{n} პოზიცია',
  'cart.empty': 'ცარიელია',
  'cart.search': 'მოძებნე — სახელი ან შტრიხკოდი',
  'cart.searchAria': 'პროდუქტის ძებნა კალათიდან',
  'cart.fullscreen': 'კალათა მთელ ეკრანზე',
  'cart.displayTitle': 'კლიენტის მონიტორი — გახსენი და გადაიტანე მეორე ეკრანზე',
  'cart.clear': 'კალათის გასუფთავება',
  'cart.noHits': '„{q}" — ვერ მოიძებნა',
  'cart.hits': 'ნაპოვნი პროდუქტები',
  'cart.kbPick': 'არჩევა',
  'cart.kbAdd': 'დამატება',
  'cart.kbClear': 'გასუფთავება',
  'cart.scanPrompt': 'დაასკანერე პროდუქტი',
  'cart.scanPromptHint': 'ან მოძებნე ზემოთ — სახელით ან შტრიხკოდით (F2)',
  'cart.emptyTitle': 'კალათა ცარიელია',
  'cart.emptyHint': 'პროდუქტზე დაჭერით დაამატეთ',
  'cart.wholesaleShort': 'საბ.',
  'cart.less': 'ნაკლები',
  'cart.more': 'მეტი',
  'cart.qtyOf': '{name} — რაოდენობა',
  'cart.qtyHint': 'დააჭირე და ჩაწერე რაოდენობა',
  'pos.ingr.hint': 'ფასში: {list}',
  'pos.exp.note': 'ვადაგასული პარტია ({date}) — შეამოწმე შეფუთვა',
  'cart.remove': 'ამოღება',
  'cart.removeName': '{name} — ამოღება',
  'cart.discountPinOk': 'ფასდაკლება {pct}% — მფლობელის PIN დადასტურებულია',
  'cart.discountOver': 'ფასდაკლება {pct}% > ლიმიტი {limit}% — მფლობელის PIN დასჭირდება',
  'cart.discountLimit': 'ფასდაკლების ლიმიტი: {limit}%',
  'cart.discountAmount': 'ფიქსირებული თანხა',
  'cart.discountPercent': 'პროცენტი',
  'cart.discountPh': 'ფასდაკლება {unit}',
  'cart.discountRemove': 'ფასდაკლების მოხსნა',
  'cart.wholesaleTitle': 'საბითუმო ფასებზე გადართვა',
  'cart.wholesale': 'საბითუმო',
  'cart.positionsLabel': 'პოზიციები:',
  'cart.promos': 'აქციები:',
  // 1.58 — the customer on the cart, the box, the group price
  'pos.customerPick': 'მყიდველი — მისი ჯგუფის ფასით',
  'pos.customerNoGroup': 'ჯგუფის გარეშე — საცალო ფასი',
  'pos.customerClear': 'მყიდველის მოხსნა',
  'pos.packTag': 'ყუთის ფასი',
  'pos.packSplit': '{qty} ც = {boxes} ყუთი + {rest} ც',
  'pos.packSplitWhole': '{qty} ც = {boxes} ყუთი',
  'pos.packSaved': 'ყუთის ფასი',
  'pos.groupSaved': 'ჯგუფის ფასით დაზოგილი',
  'pos.groupRow': 'ფასის ჯგუფი',
  'pos.groupsUnread': 'მყიდველის ფასის ჯგუფი ჯერ არ ჩაიტვირთა — წამში სცადეთ ხელახლა.',
  // 1.58 — the quote before payment
  'quote.button': 'ფასის ფურცელი',
  'quote.title': 'ფასის ფურცელი',
  'quote.sub': '{n} ხაზი · {sum} · ფული და მარაგი არ იძვრება',
  'quote.buyer': 'მყიდველი',
  'quote.buyerPh': 'სახელი ან კომპანია',
  'quote.tin': 'საიდენტიფიკაციო კოდი',
  'quote.address': 'მისამართი',
  'quote.valid': 'მოქმედებს',
  'quote.days': '{n} დღე',
  'quote.until': '{date}-მდე',
  'quote.lessDays': 'ნაკლები დღე',
  'quote.moreDays': 'მეტი დღე',
  'quote.note': 'შენიშვნა',
  'quote.keepHint': 'შენახული ფურცელი გადადებულ კალათებში ჩნდება. როცა მყიდველი დაბრუნდება, კალათა იმ დღის ფასებით გაიხსნება.',
  'quote.printHint': 'ფურცელი იბეჭდება. კალათა რჩება სალაროში.',
  'quote.print': 'ბეჭდვა',
  'quote.keepPrint': 'შენახვა და ბეჭდვა',
  'quote.kept': 'ფასის ფურცელი შენახულია გადადებულ კალათებში',
  'quote.label': 'შეთავაზება № {no} · {buyer}',
  'quote.reprint': 'ხელახლა ბეჭდვა',
  'quote.popupBlocked': 'ბეჭდვის ფანჯარა დაიბლოკა — ბრაუზერში pop-up ნება დართეთ',
  'cart.subtotal': 'ქვეჯამი:',
  'cart.discount': 'ფასდაკლება',
  'cart.bonusPaid': 'ბონუსით:',
  'cart.total': 'სულ:',
  'cart.debt': 'ვალი {sum}',
  'cart.fullyPaid': 'სრულად გადახდილი',
  'cart.whichTerminal': 'რომელი ბანკის ტერმინალი?',
  'cart.scanInConfirm': 'ფანჯარა ღიაა — ნივთი არ დაემატა. დახურე და თავიდან დაასკანერე.',
  'cart.bonusEarn': 'ამ ყიდვიდან დაერიცხება +{sum}',
  'cart.pickCustomer': 'აირჩიეთ კლიენტი...',
  'cart.noCustomers': 'კლიენტი არ არის — დაამატე →',
  'cart.paidNow': 'გადახდილი ახლა (0 = სრულად ვალში)',
  'cart.inDebt': 'ვალში',
  'cart.heldCarts': 'გადადებული კალათები',
  'cart.holdTitle': 'კალათის გადადება (F10)',
  'cart.holdOffline': 'გადადება offline-ში მიუწვდომელია',
  'cart.hold': 'გადადება',
  'cart.sell': 'გაყიდვა',
  'cart.searchProduct': 'პროდუქტის ძებნა',
  'cart.confirmTitle': 'გაყიდვის დადასტურება',
  'cart.payment': 'გადახდა:',
  'cart.creditLine': '{name} — გადახდილი {paid}, ვალში {debt}',
  'cart.received': 'მიღებული თანხა',
  'cart.short': 'აკლია',
  'cart.change': 'ხურდა',
  // 1.53 (168) — „ხურდის თეთრები", the chips under „ხურდა"
  'cart.tetri.ask': 'წვრილი ხურდა არ გაქვთ? რამდენი დააბრუნეთ:',
  'cart.tetri.askShort': 'მომხმარებელს წვრილი არ აქვს?',
  'cart.tetri.handed': 'დაბრუნდა {sum}',
  'cart.tetri.kept': '{n} თეთრი დარჩა',
  'cart.tetri.added': '{n} თეთრი დავამატეთ',
  'cart.tetri.forgive': '{n} თეთრი ვაპატიეთ',
  'cart.tetri.stays': 'გაყიდვა {sum} რჩება',
  'cart.tetri.forgiven': 'ვაპატიეთ',
  'cart.tetri.noteKept': '{n} თეთრი მაღაზიას დარჩა — სალაროში ამდენით მეტი უნდა იყოს.',
  'cart.tetri.noteAdded': '{n} თეთრი დავამატეთ — სალაროში ამდენით ნაკლები უნდა იყოს.',
  'cart.tetri.noteForgive': 'მომხმარებელმა {paid} გადაიხადა. გაყიდვა, ჩეკი და RS.GE რჩება {sum}; სალაროში {n} თეთრით ნაკლები უნდა იყოს.',
  'cart.exact': 'ზუსტად',
  'cart.ownerPin': 'მფლობელის PIN',
  'cart.ownerPinBody': 'ფასდაკლება {pct} აჭარბებს ამ მოლარის ლიმიტს ({limit}%). გასაგრძელებლად მფლობელმა უნდა ჩაწეროს სისტემის PIN.',
  'cart.clearBody': 'ნამდვილად გსურთ კალათის გასუფთავება? ამოღებული ჩაიწერება — მფლობელი ხედავს, რა და რა თანხით ამოიღეს.',
  'cart.clearDo': 'გასუფთავება',
  'cart.noHeld': 'გადადებული კალათა არ არის',
  'cart.receipt': 'ქვითარი',

  // 128 — IMEI / serial numbers at the till, and the warranty card
  'serial.askTitle': 'IMEI / სერიული ნომერი',
  'serial.askUnit': '{name} · ერთეული {n}',
  'serial.askHint': 'დაასკანერე ყუთზე ან ტელეფონში (*#06#), ან ჩაწერე ხელით.',
  'serial.placeholder': 'მაგ. 356938035643809',
  'serial.add': 'დამატება',
  'serial.addAnyway': 'მაინც დამატება',
  'serial.checking': 'ვამოწმებ…',
  'serial.err.empty': 'ჩაწერე ან დაასკანერე ნომერი.',
  'serial.err.tooShort': 'ნომერი ძალიან მოკლეა.',
  'serial.err.tooLong': 'ნომერი 40 სიმბოლოზე გრძელია.',
  'serial.err.chars': 'ნომერში შეიძლება მხოლოდ ლათინური ასოები, ციფრები და - / .',
  'serial.err.checksum': 'ამ IMEI-ს ბოლო ციფრი არ ემთხვევა — ერთი ციფრი ალბათ შეცდომითაა. გადაამოწმე ან დააჭირე „მაინც დამატება".',
  'serial.err.inCart': 'ეს ნომერი კალათაში უკვე არის.',
  'serial.warn.sold': 'ეს ნომერი უკვე გაყიდულია: {date}, {branch}. თუ ტელეფონი დაბრუნდა, ჯერ დაბრუნება გააფორმე.',
  'serial.chipRemove': '{serial} — ამოღება',
  'serial.kioskRefuse': '„{name}" სალაროში იყიდება — IMEI უნდა ჩაიწეროს.',
  'warranty.open': 'IMEI / გარანტია',
  'warranty.title': 'IMEI / გარანტია',
  'warranty.placeholder': 'IMEI ან სერიული ნომერი',
  'warranty.search': 'ძებნა',
  'warranty.notFound': 'ეს ნომერი ამ მაღაზიაში არ გაყიდულა.',
  'warranty.offline': 'ინტერნეტი არ არის — ძებნა ვერ მოხერხდა.',
  'warranty.state.sold': 'გაყიდულია',
  'warranty.state.returned': 'დაბრუნებულია — მაღაზიაშია',
  'warranty.active': 'გარანტია მოქმედებს {date}-მდე · დარჩა {n} დღე',
  'warranty.expired': 'გარანტია ამოიწურა {date}-ს',
  'warranty.none': 'ამ ერთეულს გარანტია არ ჰქონდა',
  'warranty.ev.sale': 'გაიყიდა',
  'warranty.ev.return': 'დაბრუნდა',
  'warranty.receiptNo': 'ჩეკი №{n}',
  'warranty.cashier': 'მოლარე: {name}',
  'warranty.customer': 'კლიენტი: {name}',
  'warranty.until': 'გარანტია {date}-მდე',

  // 130 — repairs
  'rep.title': 'შეკეთება',
  'rep.subtitle': 'მიღებული ნივთები და მათი სტატუსი',
  'rep.new': 'მიღება',
  'rep.search': 'ძებნა: ნომერი, სახელი, ტელეფონი, IMEI',
  'rep.empty': 'შეკეთებაზე ჯერ არაფერი მიგიღია.',
  'rep.filter.open': 'სახელოსნოში',
  'rep.filter.all': 'ყველა',
  'rep.st.received': 'მიღებულია',
  'rep.st.in_progress': 'შეკეთებაშია',
  'rep.st.ready': 'მზადაა',
  'rep.st.returned': 'გაცემულია',
  'rep.st.cancelled': 'გაუქმებულია',
  'rep.go.in_progress': 'შეკეთება დაიწყო',
  'rep.go.ready': 'მზადაა',
  'rep.cancel': 'გაუქმება',
  'rep.f.customer': 'კლიენტი',
  'rep.f.phone': 'ტელეფონი',
  'rep.f.device': 'მოწყობილობა',
  'rep.f.devicePh': 'მაგ. iPhone 13, შავი',
  'rep.f.serial': 'IMEI / სერიული',
  'rep.f.problem': 'პრობლემა',
  'rep.f.problemPh': 'რას უჩივის კლიენტი',
  'rep.f.accessories': 'თან დატოვა',
  'rep.f.accessoriesPh': 'დამტენი, ქეისი…',
  'rep.f.condition': 'მდგომარეობა',
  'rep.f.conditionPh': 'ნაკაწრი, გატეხილი უკანა მხარე…',
  'rep.f.technician': 'ხელოსანი',
  'rep.f.estimate': 'სავარაუდო ფასი, ₾',
  'rep.f.final': 'საბოლოო ფასი, ₾',
  'rep.f.note': 'რა გაკეთდა',
  'rep.f.warranty': 'საგარანტიო შეკეთება — უფასოდ',
  'rep.save': 'მიღება და ქვითრის ბეჭდვა',
  'rep.saved': '{no} მიღებულია',
  'rep.update': 'შენახვა',
  'rep.err.save': 'შეკეთება ვერ შეინახა',
  'rep.err.required': 'კლიენტი, მოწყობილობა და პრობლემა სავალდებულოა.',
  'rep.print': 'ქვითარი',
  'rep.whatsapp': 'WhatsApp: მზადაა',
  'rep.noPhone': 'ტელეფონი არ წერია — WhatsApp ვერ გაიგზავნება.',
  'rep.charge': 'გადახდა სალაროში · {sum}',
  'rep.handBack': 'გაცემა (უფასოდ)',
  'rep.chargedHint': '{no} სალაროს კალათაშია — დაასრულე გაყიდვა.',
  'rep.boughtHere': 'ჩვენთან ნაყიდი: {date}',
  'rep.fromWarranty': 'შეკეთებაზე მიღება',
  'rep.cartDone': '{no} გაცემულად მოინიშნა',
  'rep.cartFail': 'გაყიდვა შედგა, მაგრამ {no}-ის სტატუსი ვერ შეიცვალა — მონიშნე გაცემულად შეკეთების გვერდზე.',
  'rep.dates': 'მიღება {in}',
  'rep.dueLabel': 'გადასახდელი',
  // 1.36 — the exchange („გაცვლა")
  'exch.open': 'გაცვლა',
  'exch.title': 'გაცვლა',
  'exch.find': 'რა ბრუნდება',
  'exch.findHint': 'დაასკანერეთ ნივთი ან ჩაწერეთ სახელი',
  'exch.receipt': 'ჩეკის № (არასავალდებულო)',
  'exch.search': 'ძებნა',
  'exch.noSales': 'ამ ნივთის გაყიდვა ვერ მოიძებნა',
  'exch.more': 'მეტის ჩვენება',
  'exch.paidUnit': '{sum} / ცალი',
  'exch.receiptNo': 'ჩეკი №{no}',
  'exch.late': 'ვადაგასული · მფლობელის PIN',
  'exch.blocked.credit': 'ნისია — მფლობელთან',
  'exch.blocked.bonus': 'ბონუსი — მფლობელთან',
  'exch.blocked.serial': 'IMEI — გარანტიის ეკრანი',
  'exch.blocked.weighed': 'წონითი — მფლობელთან',
  'exch.left': 'დარჩა {n}',
  'exch.allBack': 'უკვე დაბრუნდა',
  'exch.change': 'შეცვლა',
  'exch.howMany': 'რამდენი ბრუნდება',
  'exch.new': 'რას იღებს',
  'exch.sameModel': 'იგივე მოდელი — სხვა ზომა / ფერი',
  'exch.other': 'სხვა ნივთი',
  'exch.otherHint': 'დაასკანერეთ ან ჩაწერეთ სახელი',
  'exch.swap': 'ზომის გაცვლა',
  'exch.remove': 'წაშლა',
  'exch.outOfStock': '{name} — მარაგში არ არის',
  'exch.credited': 'ჩაბარდა',
  'exch.newTotal': 'ახალი',
  'exch.toPay': 'გადასახდელი',
  'exch.cheaper': 'ახალი ნივთი იაფია — დაამატეთ ნივთი, ან დაბრუნება მფლობელთან',
  'exch.cash': 'ნაღდი',
  'exch.card': 'ბარათი',
  'exch.sameBank': 'ბარათით — იგივე ბანკი ({bank})',
  'exch.pin': 'მფლობელის PIN — ვადა გასულია',
  'exch.do': 'გაცვლა',
  'exch.done': 'გაცვლა შესრულდა',
  'exch.doneBody': 'ჩაბარდა {credited} · ახალი {newTotal} · გადახდილი {paid}',
  'exch.print': 'ჩეკის ბეჭდვა',
  'exch.printBlocked': 'ბრაუზერმა ბეჭდვის ფანჯარა დაბლოკა',
  'exch.close': 'დახურვა',
  'exch.offline': 'გაცვლას ინტერნეტი სჭირდება',
  'exch.retry': 'კავშირი გაწყდა. სცადეთ ხელახლა — იგივე გაცვლა ორჯერ არ ჩაიწერება',
  'exch.err.cheaper': 'ახალი ნივთი იაფია (ჩაბარდა ₾{a}, ახალი ₾{b})',
  'exch.err.window': 'ვადა ({days} დღე) გასულია — საჭიროა მფლობელის PIN',
  'exch.err.pin': 'PIN არასწორია',
  'exch.err.pinLocked': 'ძალიან ბევრი ცდა — სცადეთ მოგვიანებით',
  'exch.err.shift': 'ჯერ გახსენით ცვლა ამ ფილიალში',
  'exch.err.credit': 'ნისიით ნაყიდის გაცვლა — მფლობელთან (დაბრუნება + გაყიდვა)',
  'exch.err.bonus': 'ბონუსიანი გაყიდვის გაცვლა — მფლობელთან (დაბრუნება + გაყიდვა)',
  'exch.err.fiscal': 'ფისკალური აპარატით გაცვლა ჯერ არ მუშაობს — მფლობელთან',
  'exch.err.serial': 'IMEI-იანი ნივთი იცვლება გარანტიის ეკრანიდან',
  'exch.err.weighed': 'წონით პროდუქტზე გაცვლა არ ფორმდება: დაბრუნებას მფლობელი გააფორმებს, ახალი კი ჩვეულებრივად გაიყიდება',
  'exch.err.stock': '{name} — მარაგში აღარ არის',
  'exch.err.price': 'ფასი შეიცვალა — გახსენით გაცვლა თავიდან',
  'exch.err.bank': 'ბარათით მხოლოდ იმავე ბანკში',
  'exch.err.room': 'ეს ნივთი ამ ჩეკიდან უკვე დაბრუნდა',
  'exch.err.generic': 'გაცვლა ვერ შესრულდა',
  'exch.err.lost': 'კავშირი გაწყდა',
  'pos.attach.action': 'მიაბი პროდუქტს',
  'pos.attach.title': 'კოდის მიბმა',
  'pos.attach.subtitle': 'კოდი {code} — რომელ პროდუქტს ეკუთვნის?',
  'pos.attach.search': 'მოძებნე სახელით ან კოდით',
  'pos.attach.hint': 'ყველაზე სწრაფად: დაასკანერე იმავე საქონლის ძველი კოდი.',
  'pos.attach.ask': 'მივაბა კოდი {code} პროდუქტს „{name}"?',
  'pos.attach.confirm': 'დადასტურება',
  'pos.attach.back': 'სხვა პროდუქტი',
  'pos.attach.done': 'კოდი მიება ✓ {name}',
  'pos.attach.same': 'ეს ის კოდია, რომელსაც ვაბამთ — დაასკანერე პროდუქტის ძველი კოდი',
  'pos.attach.unknownScan': 'ეს კოდიც უცნობია: {code}',
  'pos.attach.none': 'ვერაფერი მოიძებნა',
  'pos.attach.closeFirst': 'ჯერ დახურე გახსნილი ფანჯარა',
  // 1.40 — the „რამდენი?" window for a product sold by weight (no electronic scale)
  'pos.weight.title': 'რამდენი?',
  'pos.weight.price': '₾{price} / {unit}',
  'pos.weight.stock': 'ნაშთში: {n} {unit}',
  'pos.weight.inCart': 'კალათაში უკვე: {n} {unit}',
  'pos.weight.byWeight': 'წონით',
  'pos.weight.byAmount': 'თანხით',
  'pos.weight.grams': '= {g} გ',
  'pos.weight.millilitres': '= {g} მლ',
  'pos.weight.forAmount': '= {n} {unit}',
  'pos.weight.overStock': 'ნაშთში მხოლოდ {n} {unit}',
  'pos.weight.tooSmall': 'ძალიან ცოტაა — მინიმუმ 0.001 {unit}',
  'pos.weight.add': 'დამატება',
  'pos.weight.cancel': 'გაუქმება',
  'pos.weight.tabHint': 'Tab — წონით / თანხით · Enter — დამატება',
  'pos.weight.scanBlocked': 'ჯერ ჩაწერე რამდენი, ან დახურე ფანჯარა',
  'pos.weight.wholeOnly': 'ცალობით — მთელი რიცხვი',
  'pos.weight.enterHint': 'Enter — დამატება',
  'pos.weight.bundle': 'კომბო-აქციაშია — თანხას კალათა დაითვლის',
  'pos.weight.added': '✓ {name} — {n} {unit}',
  // 1.52 — the scale on a cable: the chip beside search and the text tiles
  'pos.scale.kg': '{kg} კგ',
  'pos.scale.stable': 'სტაბილური',
  'pos.scale.moving': 'მერყეობს',
  'pos.scale.needZero': 'ჯერ ნული',
  'pos.scale.empty': 'მზადაა',
  'pos.scale.negative': 'ნულზე ნაკლები',
  'pos.scale.connecting': 'ვუკავშირდები…',
  'pos.scale.off': 'სასწორი გათიშულია',
  'pos.scale.connect': 'შეერთება',
  'pos.scale.busy': 'სასწორი სხვა ფანჯარაშია ღია',
  'pos.scale.ambiguous': 'აირჩიე სასწორი',
  'pos.scale.notFound': 'სასწორი ვერ ვიცანით — შეამოწმე პარამეტრებში',
  'pos.scale.err.overload': 'გადატვირთულია',
  'pos.scale.err.other': 'შეცდომა',
  'pos.scale.weighing': 'იწონება…',
  'pos.scale.perUnit': '₾{price} / {unit}',
  'pos.scale.oneUnit': '1 {unit}',
  // 1.52 — „რამდენი?" with the scale's live weight, and a pick that lost its cart
  'pos.scale.onScale': 'სასწორზე:',
  'pos.scale.why.moving': 'დაელოდე, სანამ წონა დადგება',
  'pos.scale.why.needZero': 'წინა პროდუქტი აიღე სასწორიდან და ეს ისევ დადე — ან წონა ხელით ჩაწერე',
  'pos.scale.why.empty': 'დადე პროდუქტი სასწორზე',
  'pos.scale.why.lost': 'სასწორი გათიშულია — ჩაწერე ხელით',
  'pos.scale.why.busy': 'სასწორი სხვა ფანჯარაშია ღია — ჩაწერე ხელით',
  'pos.scale.why.ambiguous': 'სასწორი არჩეული არ არის — ჩაწერე ხელით',
  'pos.scale.why.timeout': 'სასწორმა დროზე არ უპასუხა — ჩაწერე ხელით',
  'pos.scale.why.negative': 'წონა ნულზე ნაკლებია — შეამოწმე ტარა',
  'pos.scale.why.badTare': 'სასწორის ტარა გაუგებარია — გაანულე სასწორი',
  'pos.scale.dropped': 'აწონვა გაუქმდა — კალათა შეიცვალა',
  // 1.57 — the gift card and the deposit (lib/prepaid.ts prepaidErrorKey)
  'pp.err.notFound': 'წინასწარი თანხა ვერ მოიძებნა',
  'pp.err.insufficient': 'ამ ბარათზე მხოლოდ {sum} არის',
  'pp.err.expired': 'ამ ბარათს ვადა {date}-ს გაუვიდა',
  'pp.err.codeRequired': 'სასაჩუქრე ბარათი მხოლოდ სრული კოდით იხარჯება — დაასკანერე ან ჩაწერე მთლიანად',
  'pp.err.oneOnly': 'ერთ გაყიდვაზე მხოლოდ ერთი წინასწარი თანხა',
  'pp.err.withCredit': 'წინასწარ თანხასთან ერთად ნისია არ იწერება — დანარჩენი ნაღდით ან ბარათით',
  'pp.err.rails': 'გადახდა ჯამს ვერ ფარავს — დანარჩენი ნაღდით ან ბარათით',
  'pp.err.fiscal': 'წინასწარი თანხით გადახდილი გაყიდვა ფისკალურ ჩეკად ჯერ ვერ იბეჭდება',
  'pp.err.notHere': 'წინასწარი თანხა აქ ვერ გამოიყენება — მხოლოდ ინტერნეტით, QR-ის გარეშე',
  'pp.err.codeTaken': 'ეს კოდი უკვე დაკავებულია',
  'pp.err.codeShape': 'კოდი 6–32 სიმბოლოა: ციფრები, ლათინური ასოები და ტირე',
  'pp.err.fields': 'შეავსე: ვისია და რისთვის',
  'pp.err.expiryPast': 'ვადა წარსულში ვერ იქნება',
  'pp.err.method': 'აირჩიე როგორ გადაიხადა — ბარათზე ან გადარიცხვაზე ბანკიც',
  'pp.err.returnRails': 'დაბრუნების თანხები განახლდა: ნაღდი {cash}, ბარათი {card}, წინასწარ თანხაზე {prepaid}',
  'pp.err.exchange': 'წინასწარი თანხით გადახდილი გაყიდვა არ იცვლება — დააბრუნე და ხელახლა გაყიდე',
  'pp.offline': 'წინასწარი თანხა მხოლოდ ინტერნეტით — კავშირი არ არის',
  'pp.closedShiftList': 'სასაჩუქრე ბარათები და ავანსები',
  'pp.refund.noShift': 'ცვლა დახურულია: თანხის დაბრუნება მხოლოდ გადარიცხვით შეიძლება — ნაღდს და ბარათს სალარო სჭირდება.',
  'pp.netLost': 'კავშირი გაწყდა — დააჭირე ხელახლა იგივეს: ორჯერ არ ჩამოიჭრება',
  'pp.err.issue': 'წინასწარი თანხა ვერ შეინახა',
  'pp.err.refund': 'თანხა ვერ დაბრუნდა',
  'pp.err.list': 'წინასწარი თანხები ვერ ჩაიტვირთა',
  'pp.returnedTo': '{sum} დაბრუნდა წინასწარ თანხაზე ••••{tail} · ნაშთი {bal}',
  'pp.err.off': 'სასაჩუქრე ბარათი და წინასწარი გადახდა ამ მაღაზიაში გამორთულია — ახალი თანხა არ მიიღება',
  'pp.err.details': 'ცვლილება ვერ შეინახა',
  // 1.57 — the till: the header menu, the two issue windows, spending, the list
  'pp.menu': 'წინასწარი თანხები',
  'pp.menu.gift': 'სასაჩუქრე ბარათის გაყიდვა',
  'pp.menu.giftSub': 'თანხა ბარათზე, კოდით',
  'pp.menu.deposit': 'წინასწარი გადახდა',
  'pp.menu.depositSub': 'შეკვეთა ან გადადებული ნივთი',
  'pp.menu.list': 'წინასწარი თანხები',
  'pp.menu.listSub': 'ღია: {n} · გვმართებს {sum}',
  'pp.menu.listEmpty': 'სია, ისტორია, დაბრუნება',
  'pp.gift.title': 'სასაჩუქრე ბარათი',
  'pp.gift.sub': 'ეს გაყიდვა არ არის — ბრუნვაში ჩაითვლება, როცა ბარათს დახარჯავენ',
  'pp.dep.title': 'წინასწარი გადახდა',
  'pp.dep.sub': 'შეკვეთა ან გადადებული ნივთი · ნივთის გაცემისას ჩაითვლება',
  'pp.amount': 'თანხა',
  'pp.dep.amount': 'რამდენს იხდის ახლა',
  'pp.dep.left': 'აღებისას დარჩება გადასახდელი {sum} (დღევანდელი ფასით)',
  'pp.method': 'როგორ გადაიხადა',
  'pp.method.cash': 'ნაღდი',
  'pp.method.card': 'ბარათი',
  'pp.method.transfer': 'გადარიცხვა',
  'pp.bank': 'რომელ ბანკში',
  'pp.expiry': 'ვადა',
  'pp.expiry.none': 'უვადო',
  'pp.expiry.6m': '6 თვე',
  'pp.expiry.1y': '1 წელი',
  'pp.buyer': 'მყიდველი (არ არის სავალდებულო)',
  'pp.buyerPh': 'სახელი ან ტელეფონი',
  'pp.scan': 'მზა პლასტიკური ბარათი გაქვს? დაასკანერე მისი კოდი',
  'pp.scanPh': 'ცარიელი — კოდს სისტემა შექმნის და ქაღალდზე დაბეჭდავს',
  'pp.dep.customer': 'კლიენტი',
  'pp.dep.orType': 'ან ჩაწერე',
  'pp.dep.pickCustomer': 'აირჩიე კლიენტი სიიდან',
  'pp.dep.name': 'სახელი',
  'pp.dep.phone': 'ტელეფონი',
  'pp.dep.note': 'რისთვის',
  'pp.dep.notePh': 'მაგ.: AirPods Pro 2 — შეკვეთა მომწოდებელთან',
  'pp.dep.fromCart': 'კალათიდან: {n} ნივთი · {sum}',
  'pp.dep.fromCartSub': '{names} — კალათა დაცარიელდება',
  'pp.dep.notReserved': 'მარაგში არ დაჯავშნილა — ნივთი ფიზიკურად გადადეთ',
  'pp.dep.due': 'როდის წაიღებს (არ არის სავალდებულო)',
  'pp.issue.gift': 'მიღება და ბეჭდვა · {sum}',
  'pp.issue.dep': 'მიღება და ქვითარი · {sum}',
  'pp.issued.gift': 'სასაჩუქრე ბარათი გაიყიდა — {sum}',
  'pp.issued.dep': 'წინასწარი თანხა მიღებულია — {sum}',
  'pp.err.amount': 'ჩაწერე თანხა',
  'pp.err.bank': 'აირჩიე ბანკი',
  'pp.redeem.title': 'წინასწარი თანხა',
  'pp.redeem.due': 'დასახდელია {sum}',
  'pp.redeem.search': 'დაასკანერე ბარათი, ან ჩაწერე სახელი / ტელეფონი',
  'pp.redeem.giftHint': 'სასაჩუქრე ბარათი სახელით არ იძებნება — დაასკანერე ან ჩაწერე მისი სრული კოდი.',
  'pp.redeem.none': 'ვერაფერი მოიძებნა',
  'pp.redeem.find': 'ძებნა',
  'pp.redeem.use': 'გამოიყენე',
  'pp.redeem.line': 'ბალანსი {bal} · დარჩება {left} · დარჩება გადასახდელი {due}',
  'pp.redeem.load': 'გადადებული {n} ნივთი კალათაში ჩაიტვირთოს (დღევანდელი ფასით)',
  'pp.redeem.loadReplace': 'რაც ახლა კალათაშია, ჩანაცვლდება',
  'pp.redeem.apply': 'გამოყენება · {sum}',
  'pp.redeem.expired': 'ვადა გაუვიდა {date}',
  'pp.redeem.notOpen': 'ეს თანხა უკვე დახარჯულია ან დაბრუნებულია',
  'pp.giftRow': 'სასაჩუქრე ბარათი ••••{tail}',
  'pp.items': '{n} ნივთი',
  'pp.pickup': 'აღება {date}',
  'pp.strip.dep': 'წინასწარი თანხა — {name}',
  'pp.strip.sub': 'იყო {bal} · დარჩება {left}',
  'pp.strip.remove': 'მოხსნა',
  'pp.button': 'წინასწარი თანხა (ბარათი ან შეკვეთა)',
  'pp.left': 'დარჩა გადასახდელი',
  'pp.paidFull': 'სრულად დაიფარა წინასწარი თანხით',
  'pp.fiscalOff': 'წინასწარი თანხით გაყიდვა ფისკალურ ჩეკად არ იბეჭდება',
  'pp.methodPart': '{sum} წინასწარი',
  'pp.list.title': 'წინასწარი თანხები',
  'pp.list.sum': 'გვმართებს {sum} · ბარათები {gift} · შეკვეთები {dep}',
  'pp.list.open': 'ღია · {n}',
  'pp.list.closed': 'დახურული',
  'pp.list.search': 'სახელი, ტელეფონი ან კოდი',
  'pp.list.who': 'ვისი / რისთვის',
  'pp.list.balance': 'ბალანსი',
  'pp.list.date': 'თარიღი',
  'pp.list.action': 'მოქმედება',
  'pp.list.from': 'თავიდან {sum}',
  'pp.list.boughtBy': 'იყიდა: {name}',
  'pp.list.overdue': 'აღება {date} · გადაცდა',
  'pp.list.expires': 'ვადა {date}',
  'pp.list.expired': 'ვადა გავიდა {date}',
  'pp.list.itemsAside': '{n} ნივთი გადადებული',
  'pp.list.spent': 'დახარჯულია',
  'pp.list.refunded': 'დაბრუნებულია',
  'pp.list.refund': 'დაბრუნება',
  'pp.list.history': 'ისტორია და დეტალები',
  'pp.list.ownerOnly': '„დაბრუნება" — მხოლოდ მფლობელს ჩანს. მოლარე ხედავს სიას, ბარათის კოდის ბოლო 4 ციფრით.',
  'pp.list.empty': 'წინასწარი თანხა ჯერ არ არის',
  'pp.list.more': 'ნაჩვენებია უახლესი 200 — დააზუსტე ძებნა',
  'pp.refund.title': 'თანხის დაბრუნება',
  'pp.refund.body': '{who} — ბალანსი {sum}. რამდენი და როგორ ბრუნდება?',
  'pp.refund.note': 'შენიშვნა (არ არის სავალდებულო)',
  'pp.refund.do': 'დაბრუნება · {sum}',
  'pp.refund.done': 'დაბრუნდა {sum}',
  'pp.hist.issue': 'მიღება',
  'pp.hist.redeem': 'გაყიდვაში დაიხარჯა',
  'pp.hist.return': 'დაბრუნებით ჩაირიცხა',
  'pp.hist.refund': 'თანხა დაუბრუნდა',
  'pp.hist.empty': 'მოძრაობა არ არის',
  'pp.det.save': 'შენახვა',
  'pp.det.saved': 'შენახულია',
  'pp.det.print': 'ხელახლა ბეჭდვა',
  'pp.det.expiryOwner': 'ვადას მხოლოდ მფლობელი ცვლის',
} as const
